import { useState } from 'react';
import styles from './ClinicalTrialShared.module.scss';
import { Skeleton } from '@medifind/shared-basic-components';
import { ExpandButton } from '@medifind/shared-basic-components';
import { Button, ReadMore } from '@medifind/shared-basic-components';

const ClinicalTrialAbstract = ({ abstract = [], isLoading }) => {
  const abstractLength = abstract && abstract.length;
  const [isExpanded, setIsExpanded] = useState(false);
  // If the first abstract string is shorter than X characters it may be a header so we display the second one as well.
  const defaultLength = abstract && abstract[0]?.length > 100 ? 1 : 2;
  return (
    <div>
      <div className={styles['article__summary-title']}>SUMMARY</div>
      {abstract && abstract?.length > 0 ? (
        <div className={styles['article__summary-body']}>
          <ReadMore collapsedHeight={400} height={400} btnColor="white-blue">
            {abstract.map(({ title, text }, index) => {
              const { style, display } = title;
              return (
                <p key={`${index}-p`}>
                  {display ? (
                    <>
                      <span style={{ ...(style?.includes('bold') && { fontWeight: 'bold' }) }}>{display}</span>
                    </>
                  ) : null}{' '}
                  {text}
                </p>
              );
            })}
          </ReadMore>
        </div>
      ) : (
        <Skeleton count={5} />
      )}
    </div>
  );
};

export { ClinicalTrialAbstract as default, ClinicalTrialAbstract };
